import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import AdditionalInformation from "gatsby-theme-blank/src/components/additional-information"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import {
  pageAddress,
  pageAddressAdditionalInfos,
  addressContent,
  addressContentContainer,
  addressTitle,
  addressAddress,
  addressImage,
  addressBody,
  addressContact,
  addressMail,
  addressTel,
  addressFooter,
  addressFooterBack,
  addressPlace,
  addressPlaceIcon,
  addressPlaceTitle,
  editButton,
} from "./styles/detailsAddress.module.scss"
import Carousel from "gatsby-theme-blank/src/components/Carousel/carousel"
import PropTypes from "prop-types"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import {
  AdressAdditionalInfos,
  AdressContact,
  AdressPlaceIcon,
  AdressPlaceTitle,
  AdressFooterBack,
} from "./styled-components/adresse-styled"
import FadeIn from "react-fade-in"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import Obfuscate from "react-obfuscate"
import ProcessedLink from "gatsby-theme-blank/src/components/processed-link"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Query Graphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeCarnetDAdresse(path: { alias: { eq: $slug } }) {
      ...AdresseItem
    }
  }
`

//-----------------------Query Graphql---------------------------//

//-----------------------Parent component---------------------------//

const AdresseTemplate = ({ data }) => {
  const addressBook = data.nodeCarnetDAdresse
  const allTaxos = addressBook.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout>
      <SEO
        title={addressBook.title}
        description={
          "Dans cette page, vous découvrez l'adresse suivante : " +
          addressBook.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          addressBook.relationships?.field_image_adresse?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <FadeIn delay={250}>
        <Ariane
          pageNameLink="/adresses"
          pageName="Carnet d'adresses"
          isDetail={true}
          postName={addressBook.title}
        />
        <section className={pageAddress}>
          <AddressContent address={addressBook} />
          <AddressFooter />
        </section>
        <AddressInfos address={addressBook} />
      </FadeIn>
    </Layout>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const AddressContent = ({ address }) => (
  <div className={addressContent}>
    <article className={addressContentContainer}>
      <h1 className={addressTitle}>
        <EditButton
          link={"/node/" + address.drupal_internal__nid + "/edit"}
          addedClass={editButton}
        />
        {address.title}
      </h1>
      <div className={addressAddress}>
        <p>{address.field_adresse?.address_line1}</p>
        <p>{address.field_adresse?.address_line2}</p>
        <p>
          {address.field_adresse?.postal_code} {address.field_adresse?.locality}
        </p>
      </div>
      <AddressContact address={address} />
      <div className={addressImage}>
        <Carousel address={address} />
      </div>
      <div className={addressBody}>
        <ContentTransformer content={address.body?.processed} />
      </div>
      {address.field_url_lieu && (
        <div className={addressPlace}>
          <ProcessedLink link={address.field_url_lieu.uri}>
            <AdressPlaceIcon
              className={addressPlaceIcon}
              size={30}
              icon="earth"
            ></AdressPlaceIcon>
            <AdressPlaceTitle className={addressPlaceTitle}>
              {address.field_url_lieu.title}
            </AdressPlaceTitle>
          </ProcessedLink>
        </div>
      )}
    </article>
  </div>
)
//-----------------------Child component/Content---------------------------//

//-----------------------Child component/Footer---------------------------//

const AddressFooter = () => (
  <div className={addressFooter}>
    <AdressFooterBack className={addressFooterBack}>
      <TransitionFade
        arialabel="Retour à la liste des carnets d'adresses"
        link="/adresses"
      >
        Retour à la liste des carnets d&apos;adresses
      </TransitionFade>
    </AdressFooterBack>
  </div>
)
//-----------------------Child component/Footer---------------------------//

//-----------------------Child component/Infos---------------------------//
const AddressInfos = ({ address }) => (
  <>
    {address.field_infos_complementaires && (
      <AdressAdditionalInfos className={pageAddressAdditionalInfos}>
        <AdditionalInformation node={address} />
      </AdressAdditionalInfos>
    )}
  </>
)
//-----------------------Child component/Infos---------------------------//

//-----------------------Sub-Child component---------------------------//
const AddressContact = ({ address }) => (
  <>
    <AdressContact className={addressContact}>
      {address.field_mail && (
        <Obfuscate email={address.field_mail} className={addressMail} />
      )}
      {address.field_telephone && (
        <Obfuscate tel={address.field_telephone} className={addressTel} />
      )}
    </AdressContact>
  </>
)
//-----------------------Sub-Child component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//
AdresseTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}
AddressContent.propTypes = {
  address: PropTypes.object.isRequired,
}
AddressContact.propTypes = {
  address: PropTypes.object.isRequired,
}
AddressInfos.propTypes = {
  address: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default AdresseTemplate
